<template>
  <div class="image-frame-options">
    <el-form-item v-if="!border" label="图片拉伸">
      <el-select :value="mode" aria-label="图片拉伸方式" @change="setMode">
        <el-option label="整图拉伸" value="stretch" />
        <el-option label="固定边框（九宫格）" value="slice" />
      </el-select>
    </el-form-item>
    <template v-if="mode === 'slice'">
      <el-form-item label="原图切片">
        <div class="image-frame-options__sides">
          <label v-for="(side, index) in sides" :key="side.key"><span>{{ side.label }}</span><el-input-number :value="settings.slice[index]" :min="0" :max="10000" :precision="0" controls-position="right" :label="'原图' + side.label + '侧切片像素'" @change="setValue('frameSlice' + side.key, $event)" @blur="commitNumber('frameSlice' + side.key, $event)" /></label>
        </div>
      </el-form-item>
      <el-form-item label="显示边宽">
        <el-input-number :value="borderWidth" :min="0" :max="512" :precision="0" :placeholder="legacyWidth ? '使用旧版四边宽' : ''" controls-position="right" label="固定边框显示宽度（像素）" @change="setValue('frameBorderWidth', $event)" @blur="commitNumber('frameBorderWidth', $event)" />
        <p v-if="legacyWidth" class="image-frame-options__help">旧边宽为上10／右16／下15／左10，修改后统一四边。</p>
      </el-form-item>
      <el-form-item label="填充中间">
        <el-switch :value="settings.fill" aria-label="填充图片中间区域" @change="setValue('frameFill', $event)" />
      </el-form-item>
      <el-form-item label="区域背景">
        <el-button size="mini" @click="applyPanel">应用区域背景参数</el-button>
        <p class="image-frame-options__help">只固定边框，延展中间。切片按原图像素设置；请使用已裁去外围留白的图片。调整画布缩放仍会整体缩放。</p>
      </el-form-item>
    </template>
  </div>
</template>
<script>
import { imageFrameSettings } from '@/runtime/image-frame'
export default {
  inject: ['main'],
  props: { border: Boolean },
  data: () => ({ sides: [{ key: 'Top', label: '上' }, { key: 'Right', label: '右' }, { key: 'Bottom', label: '下' }, { key: 'Left', label: '左' }] }),
  computed: {
    mode () { return this.border || this.main.activeOption.imageSizing === 'slice' ? 'slice' : 'stretch' },
    settings () { return imageFrameSettings(this.main.activeOption, this.border ? 'imgborder' : 'img') },
    borderWidth () { return this.legacyWidth ? undefined : this.main.activeOption.frameBorderWidth === undefined ? 16 : this.main.activeOption.frameBorderWidth },
    legacyWidth () { return this.border && this.main.activeOption.frameBorderWidth === undefined }
  },
  methods: {
    commitNumber (key, event) {
      const raw = event && event.target && event.target.value
      if (typeof raw !== 'string' || !raw.trim() || !Number.isFinite(Number(raw))) return
      // 兼容旧数值输入：键盘输入失焦也提交，和步进按钮保持一致，不回写空值。
      this.setValue(key, Math.max(0, Math.min(key === 'frameBorderWidth' ? 512 : 10000, Math.round(Number(raw)))))
    },
    setMode (value) {
      if (value === this.mode) return
      this.$set(this.main.activeOption, 'imageSizing', value)
    },
    setValue (key, value) {
      if (value === undefined || value === null) return
      const option = this.main.activeOption
      const index = this.sides.findIndex(side => key === 'frameSlice' + side.key)
      const current = index >= 0 ? this.settings.slice[index] : key === 'frameFill' ? this.settings.fill : this.borderWidth
      if (value === current) return
      this.$set(option, key, value)
    },
    applyPanel () {
      const option = this.main.activeOption
      if (!this.border) this.$set(option, 'imageSizing', 'slice')
      this.sides.forEach(side => this.$set(option, 'frameSlice' + side.key, 40))
      this.$set(option, 'frameBorderWidth', 16)
      this.$set(option, 'frameFill', true)
    }
  }
}
</script>
<style scoped>
.image-frame-options .el-select, .image-frame-options .el-input-number { width: 100%; }
.image-frame-options__sides { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 6px; }
.image-frame-options__sides label { display: flex; align-items: center; min-width: 0; gap: 4px; }
.image-frame-options__sides label > span { flex: 0 0 auto; }
.image-frame-options__sides .el-input-number { min-width: 0; flex: 1; }
.image-frame-options__help { margin: 6px 0 0; font-size: 12px; line-height: 1.6; color: #a9b9c7; overflow-wrap: anywhere; }
</style>
